module.exports = __webpack_public_path__ + "img/704750e.png";